import { render, staticRenderFns } from "./preview-detail.vue?vue&type=template&id=b6d55380&scoped=true&"
import script from "./preview-detail.vue?vue&type=script&lang=js&"
export * from "./preview-detail.vue?vue&type=script&lang=js&"
import style0 from "./preview-detail.vue?vue&type=style&index=0&id=b6d55380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d55380",
  null
  
)

export default component.exports